import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'app-nps',
  templateUrl: './nps.component.html',
  styleUrl: './nps.component.scss'
})
export class NpsComponent {
  constructor(private dashboardService: DashboardService) { }
  noData: boolean;
  score: string;
  responses: string;
  totalResponses: string;
  private unsubscribe$ = new Subject<void>()

  ngOnInit(): void {
    this.dashboardService.buyerStatsData.pipe(takeUntil(this.unsubscribe$)).subscribe(result => {
      this.noData = result.curAvgNPSScore === null || result.curAvgNPSScore === null || result.curNPSResponses === 0;
      if (!this.noData) {
        this.score = `<div>${result.curAvgNPSScore}</div>`;
        this.responses = `<div>${parseFloat((result.curNPSResponseRate * 100).toFixed(1))}%</div>`;
        this.totalResponses = `<div>${result.curNPSResponses}</div>`;
      }
    })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
